import styled from "styled-components";
import { shade } from "polished";

export const Container = styled.div`
  color: var(--dark-grey);
  font-size: 12px;
  line-height: 14px;

  .ant-badge-status-dot {
    height: 8px;
    width: 8px;
  }
`;

export const Content = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  form {
    width: 450px;
    padding: 20px 0;
    display: flex;
    flex-direction: column;

    h1 {
      font-size: 18px;
      margin-bottom: 18px;
      text-align: left;
    }

    a {
      color: #f4ede8;
      margin-top: 24px;
      transition: color 0.2s;

      &:hover {
        color: ${shade(0.2, "#f4ede8")};
      }
    }
  }
`;

export const AvatarInput = styled.div`
  margin-bottom: 8px;
  position: relative;
  align-self: center;

  img {
    width: 156px;
    height: 166px;
    border-radius: 50%;
  }

  label {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 48px;
    height: 48px;
    background: #ff9000;
    border-radius: 50%;
    border: 0;
    cursor: pointer;
    transition: background 0.2s;

    display: flex;
    justify-content: center;
    align-items: center;

    input {
      display: none;
    }

    svg {
      width: 20px;
      height: 20px;
      color: #312e28;
    }

    &:hover {
      background: ${shade(0.2, "#ff9000")};
    }
  }
`;
